var _defs, _g, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls__disconnected-1 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls__disconnected-1",
    d: "M13.98,21.71c2.38,2.43,6.28,2.47,8.71,.09,.03-.03,.06-.06,.09-.09l7.04-7.04c2.43-2.43,2.43-6.37,0-8.8-2.43-2.43-6.37-2.43-8.8,0l-.88,.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls__disconnected-1",
    d: "M21.02,14.67c-2.38-2.43-6.28-2.47-8.71-.09-.03,.03-.06,.06-.09,.09l-7.04,7.04c-2.43,2.43-2.43,6.37,0,8.8,2.43,2.43,6.37,2.43,8.8,0l.88-.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls__disconnected-1",
    x1: 24.54,
    y1: 34.04,
    x2: 24.54,
    y2: 30.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls__disconnected-1",
    x1: 29.83,
    y1: 25.24,
    x2: 33.35,
    y2: 25.24
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls__disconnected-1",
    x1: 1.65,
    y1: 11.15,
    x2: 5.17,
    y2: 11.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls__disconnected-1",
    x1: 10.46,
    y1: 2.35,
    x2: 10.46,
    y2: 5.87
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.3fd76a8a4e9f377b8f97423c5e04e8bb.svg";
export { ForwardRef as ReactComponent };